import React from 'react';
import Header from '../Components/Header/Header'
import '../Styles/HeaderContainer.scss';
import Google from '../Assets/Images/play.jpg'
import Apple from '../Assets/Images/apple.jpg'

export default function HeaderContainer() {
  return (
    <header className="headerWrapper">
      <section className="boxWrapper">
        <h3>Download Now!</h3>
        <div className="storeWrapper">
          <a
            href="https://apps.apple.com/in/app/nbf-natural-born-fool/id1595333562"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Apple} alt="Apple Store" className="play" />
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.naturalbornfool.nbfapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Google} alt="Google Play Store" className="google" />
          </a>
        </div>

      </section>

    </header>

  )
}
